import { InputCheckbox } from '@creditornot/cb-checkbox';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import React, { ChangeEvent, CSSProperties } from 'react';
import { areEqual } from 'react-window';
import styled from 'styled-components';

import { ItemConfiguration } from 'apis/picker-api/types';
import { Typography as T } from 'common/typography';

import ItemRow from './ItemRow';
import { ItemData, ListElement } from '../types';

export type RowRendererData = {
  list: ListElement[];
  canSort?: boolean;
  itemConfigurations: ItemConfiguration[];
  selectedItemIds: string[];
  onCheckHeader: (event: ChangeEvent<HTMLInputElement>, checkedItemIds: string[]) => void;
  onCheckItem: (event: ChangeEvent<HTMLInputElement>, checkedItemId: string) => void;
  onMoveItem: (itemData: ItemData) => void;
  onRemoveItem?: (itemId: string) => void;
};

type Props = {
  index: number;
  data: RowRendererData;
  style: CSSProperties;
};

const CategoryRow = styled.div`
  display: flex;
  align-items: center;
  height: 64px;
  padding: 24px;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

const CategoryName = styled(T.Heading6)`
  margin-inline-start: 16px;
`;

const MenuEditorListRowRenderer = ({
  index,
  data: { list, canSort, itemConfigurations, selectedItemIds, onCheckHeader, onCheckItem, onMoveItem, onRemoveItem },
  style,
}: Props) => {
  const rowData = list[index];

  if (rowData.type === 'header') {
    return (
      <CategoryRow style={style}>
        <InputCheckbox
          checked={rowData.data.itemIds.length > 0 && rowData.data.itemIds.every(id => selectedItemIds.includes(id))}
          onChange={e => onCheckHeader(e, rowData.data.itemIds)}
        />
        <CategoryName>{rowData.data.name}</CategoryName>
      </CategoryRow>
    );
  }

  if (rowData.type === 'item') {
    const storageLocation = itemConfigurations.find(config => config.itemId === rowData.data.id)?.storageLocation;
    return (
      <ItemRow
        style={style}
        itemData={rowData}
        storageLocation={storageLocation || null}
        canSort={canSort}
        selectedItemIds={selectedItemIds}
        onMoveItem={onMoveItem}
        onRemoveItem={onRemoveItem}
        onCheckItem={event => onCheckItem(event, rowData.data.id)}
      />
    );
  }
  return null;
};

export default React.memo(MenuEditorListRowRenderer, areEqual);
